import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    container: {
      display: 'block',
      position: 'relative',
      cursor: 'pointer',
      userSelect: 'none',
      height: 26,
      width: 26,
      minHeight: 26,
      minWidth: 26,
      [media.smallerThanTablet]: {
        height: 36,
        width: 36,
        minHeight: 36,
        minWidth: 36,
      },
      [children('span')]: {
        position: 'absolute',
        top: 0,
        right: 0,
        height: '100%',
        width: '100%',
        borderRadius: 100,
        border: '1px solid white',
        ':after': {
          opacity: 0,
          position: 'absolute',
          transition: 'opacity 0.2s ease-in',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          content: '""',
          backgroundColor: palette.red,
          borderRadius: 20,
          width: 20,
          height: 20,
          [media.smallerThanTablet]: {
            height: 30,
            width: 30,
            minHeight: 30,
            minWidth: 30,
          },
        },
      },
      [children('input:checked ~ span')]: {
        // backgroundColor: 'white',
        ':after': {
          opacity: 1,
        },
      },
    },
    input: {
      position: 'absolute',
      opacity: 0,
      cursor: 'pointer',
      height: 0,
      width: 0,
    },
    /*checkmark: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        height: 25,
        width: 25,
        borderRadius: 25,
        border: '1px solid white',
        ':after': {
            content: '',
            position: 'absolute',
            display: 'none',
            height: 10,
            width: 10,
            borderRadius: 10,
            backgroundColor: 'white'
        }
    }*/
  });
};
